export const BackendGapTag = "<gap />";
export const FrontendGapTag = "&lt;gap /&gt;";

export function convertBackendTemplateToFrontendFormat(template: string) {
  return template.split(BackendGapTag).join(FrontendGapTag);
}

export function convertFrontendTemplateBackendFormat(template: string) {
  return template.split(FrontendGapTag).join(BackendGapTag);
}
